import {all, call, put, select, takeEvery, takeLatest} from 'redux-saga/effects';
import {AnyAction} from 'redux';
import qs from 'query-string';

import loginSelectors from '../../../login/redux/selectors';

import history from '../../../../redux/history';
import types from '../types';
import {action} from 'redux/helpers';
import ApiService from '../../../../api/ApiService';
import api from '../../../../api';
import {combineSFTP, foldersBuilder, handleVfsGroup} from '../helpers/FoldersHelper';

import {loginTypes} from '../../../login/redux';
import {partnersTypes} from 'redux/partners';
import {keyTypes} from 'redux/keys';
import {transactionsTypes} from 'redux/transactions';
import {folderTypes} from 'redux/folders';
import {IDiplomatFolder} from 'types/DiplomatFolder';
import {licenseSelectors, licenseTypes} from 'redux/license';
import {DiplomatFeature} from 'types/DiplomatFeature';
import {
   isPartnerFolder,
   isSshKeysFolder,
   isSslCertsFolder,
   isSslClientCertsFolder,
   isSslServerCertsFolder,
   isSftpServerFolder,
   isSynchroniztionFolder,
   isTransactionsFolder,
   isOpenPgpKeysFolder,
   isSshKeyPairsFolder,
} from '../helpers/utils';
import {layoutSelectors} from '..';
import {IDiplomatObject} from 'types/DiplomatObject';
import {synchronizationsTypes} from 'redux/synchronizations';
import {_inject_vfs_folders} from 'features/layout/redux/helpers/_vfs';
import {IVFSNode, IVFSNodeDiplomats, VFSNodeDiplomat} from 'types/diplomat/sftp/VFSNode';
import {isEmpty} from 'lodash';
import {IAllGroups} from 'types/diplomat/sftp/AllGroups';
import {sendSupportTicketSaga} from 'features/layout/redux/sagas/sendSupportTicketSaga';
import {FILE_SEPARATOR} from 'redux/server/hooks/useBrowseList';
import {castVfsNodes} from 'common/yup/castVfsNode';
import {sftpUsersTypes} from 'redux/sftp-user';
import {SFTP_FILESYSTEM, VFS_PATH, VFS_PATH_LENGTH} from 'common/constants';
import {baseNameComparator} from 'common/stringUtils';
import {getStatesFullSaga} from 'features/layout/redux/sagas/states';
import {INav} from 'features/layout/redux/helpers/FoldersBuilder';
import {AdminResourceType} from 'types/diplomat/settings/adminroles/AdminResourceType';

function* loadVfsNodes(): Generator {
   let vfsChilds = [] as IVFSNodeDiplomats;
   try {
      const vfspaths = [FILE_SEPARATOR];
      const pathname = window.location.pathname;

      if (pathname.indexOf(VFS_PATH) >= 0) {
         const _vfspath = pathname.slice(VFS_PATH_LENGTH + 1);
         const nodes = _vfspath.split(FILE_SEPARATOR);

         nodes.forEach((n, i) => {
            let p = '';

            for (let j = i; j >= 0; j--) {
               p = FILE_SEPARATOR + nodes[j] + p;
            }

            vfspaths.push(p);
         });
         console.debug(_vfspath, nodes, vfspaths);
      }

      for (let vfspath of vfspaths) {
         // expandVFSNode({
         //    vfspath,
         // });

         const vsfChildsRes = (yield call(
            ApiService.postSecureJson,
            api.vfsExpand,
            JSON.stringify({
               vfspath,
            })
         )) as Response;
         const _vfsChilds = (yield vsfChildsRes.json()) as IVFSNode[];
         Array.prototype.push.apply(vfsChilds, castVfsNodes(_vfsChilds, vfspath));
         // vfsChilds = castVfsNodes(_vfsChilds);
      }
   } catch (e) {
      console.debug(e);
   }

   return vfsChilds;
}

function* loadTreeNavSaga(act?: {isSkipStatesLoading?: boolean}): Generator {
   try {
      const isAuthenticated = (yield select(loginSelectors.isAuthenticated)) as ReturnType<
         typeof loginSelectors.isAuthenticated
      >;
      const isLicenseLoaded = (yield select(licenseSelectors.isLicenseLoaded)) as ReturnType<
         typeof licenseSelectors.isLicenseLoaded
      >;

      if (!isAuthenticated || !isLicenseLoaded) {
         return;
      }

      yield put(action(types.LOAD_TREE_NAV.REQUEST));

      const resFolders = (yield call(ApiService.getSecureJson, api.folders)) as Response;
      const {folders: _folders} = (yield resFolders.json()) as {folders: IDiplomatFolder[]};

      const isFeatureSupported = (yield select(licenseSelectors.isFeatureSupported)) as ReturnType<
         typeof licenseSelectors.isFeatureSupported
      >;
      const areAllowsTransactions = (yield select(
         licenseSelectors.areAllowsTransactions
      )) as boolean;

      if (!act?.isSkipStatesLoading) {
         yield call(getStatesFullSaga);
      }
      const objects = (yield select(
         layoutSelectors.filteredObjectsFromStates
      )) as IDiplomatObject[];

      // console.log(objects);

      let vfsRoot = VFSNodeDiplomat.cast(FILE_SEPARATOR); // TODO check if not permitted
      let vfsChilds = [] as IVFSNodeDiplomats;
      let vfsGroups = {groups: []} as IAllGroups;

      const rolesMap = (yield select(loginSelectors.getResourcesMap)) as ReturnType<
         typeof loginSelectors.getResourcesMap
      >;
      if (rolesMap[AdminResourceType.enum.SFTP_SERVER]) {
         try {
            const vfsFolder = _folders.find((f) => f.name === SFTP_FILESYSTEM);
            if (vfsFolder) {
               vfsRoot.parentId = vfsFolder.id;
               vfsRoot.folderId = vfsFolder.id;
            }

            vfsChilds = (yield call(loadVfsNodes)) as IVFSNodeDiplomats;
            // console.debug('vfs childs', _vfsChilds, vfsChilds);
         } catch (e) {
            console.debug(e);
         }

         try {
            const resVfsGroups = (yield call(ApiService.getSecureJson, api.vfsgroups)) as Response;
            const _vfsGroups = (yield resVfsGroups.json()) as IAllGroups;
            vfsGroups.groups = _vfsGroups.groups.sort(baseNameComparator);

            handleVfsGroup(vfsGroups.groups, _folders);
         } catch (e) {
            console.debug(e);
         }
         // const vfsChilds = VFSNodeDiplomats.cast(getVfsNodes());

         try {
            combineSFTP(_folders);
            // console.debug('folders', folders);
         } catch (e) {
            console.debug(e);
         }
      }

      const folders = [..._folders, vfsRoot, ...vfsChilds].filter((folder: IDiplomatFolder) => {
         if (isEmpty(folder)) return false;
         if (isPartnerFolder(folder) && !isFeatureSupported(DiplomatFeature.PARTNERS)) {
            return false;
         }

         if (isSshKeysFolder(folder) && !isFeatureSupported(DiplomatFeature.SSH_KEYS)) {
            return false;
         }

         if (
            (!isFeatureSupported(DiplomatFeature.SSL_CERTIFICATES) || !areAllowsTransactions) &&
            (isSslCertsFolder(folder) ||
               isSslClientCertsFolder(folder) ||
               isSslServerCertsFolder(folder))
         ) {
            return false;
         }

         if (isSftpServerFolder(folder) && !isFeatureSupported(DiplomatFeature.SFTP_SERVER)) {
            return false;
         }

         if (
            isSynchroniztionFolder(folder) &&
            !isFeatureSupported(DiplomatFeature.SYNCHRONIZATION)
         ) {
            return false;
         }

         if (
            !areAllowsTransactions &&
            (isTransactionsFolder(folder) || isOpenPgpKeysFolder(folder) || isPartnerFolder(folder))
         ) {
            return false;
         }

         return true;
      });

      const rootName = (yield select(loginSelectors.getRootFolderName)) as string;

      const {excludeEmpty} = (yield select(layoutSelectors.treeFilter)) as ReturnType<
         typeof layoutSelectors.treeFilter
      >;

      const treeNav = yield foldersBuilder.buildFolders(
         rootName,
         folders,
         [...objects, ...vfsGroups.groups],
         excludeEmpty
      );
      // console.debug('treeNav', treeNav);

      // @ts-ignore
      const [resKeys, resPartners, resTransactions] = yield all([
         call(ApiService.getSecureJson, api.keys),
         call(ApiService.getSecureJson, api.partners),
         call(ApiService.getSecureJson, api.transactions),
      ]);
      // @ts-ignore
      const [keys, partners, transactions] = yield all([
         resKeys.json(),
         resPartners.json(),
         resTransactions.json(),
      ]);
      yield put(
         action(types.LOAD_TREE_NAV.SUCCESS, {
            treeNav,
            folders,
            keys,
            partners,
            transactions,
            vfsGroups,
         })
      );
   } catch (e) {
      yield put(action(types.LOAD_TREE_NAV.ERROR, e));
      //handle 401
      if ((e as Response).status === 401) {
         yield put(action(loginTypes.LOGIN.ERROR, e));
      }
   }
}

function* filterNav(act: AnyAction) {
   try {
      const rootName = (yield select(loginSelectors.getRootFolderName)) as string;
      const objects = (yield select(
         layoutSelectors.filteredObjectsFromStates
      )) as IDiplomatObject[];
      const folders = (yield select(layoutSelectors.getFolders)) as ReturnType<
         typeof layoutSelectors.getFolders
      >;
      const vfsGroups = (yield select(layoutSelectors.vfsGroupsSelector)) as ReturnType<
         typeof layoutSelectors.vfsGroupsSelector
      >;
      const {excludeEmpty} = (yield select(layoutSelectors.treeFilter)) as ReturnType<
         typeof layoutSelectors.treeFilter
      >;

      console.debug('filterNav', act);

      const treeNav = (yield foldersBuilder.buildFolders(
         rootName,
         folders,
         [...objects, ...vfsGroups.groups],
         excludeEmpty
      )) as INav[];

      yield put(
         action(types.LOAD_TREE_NAV.SUCCESS, {
            treeNav,
         })
      );
   } catch (e) {
      yield put(action(types.LOAD_TREE_NAV.ERROR, e));
      //handle 401
      if ((e as Response).status === 401) {
         yield put(action(loginTypes.LOGIN.ERROR, e));
      }
   }
}

function* openDialogSaga(act: AnyAction) {
   // console.debug('Open Dialog saga', act, history);
   try {
      // const pathname = window.location.pathname === '/' ? '': window.location.pathname;
      const parsedQuery = qs.parse(window.location.search);
      parsedQuery.dialog = act.payload;

      yield call(history.push as any, {search: qs.stringify(parsedQuery)});
   } catch (e) {
      console.error(e);
   }
}

export function* modalDialogsSaga() {
   yield takeEvery(types.OPEN_DIALOG, openDialogSaga);
   yield takeLatest(types.SEND_SUPPORT_TICKET.SAGA, sendSupportTicketSaga);
   yield takeLatest(types.TREE_SEARCH, filterNav);

   yield takeLatest(
      [
         types.LOAD_TREE_NAV.SAGA,

         loginTypes.LOGIN.SUCCESS,
         licenseTypes.GET_LICENSE.SUCCESS,

         folderTypes.ADD_SUB_FOLDER.SUCCESS,
         folderTypes.RENAME_SUB_FOLDER.SUCCESS,
         folderTypes.DELETE_SUB_FOLDER.SUCCESS,
         folderTypes.MOVE_SUB_FOLDER.SUCCESS,

         keyTypes.MOVE_KEYS.SUCCESS,
         keyTypes.CREATE_SSH_KEY_PAIR.SUCCESS,
         keyTypes.CREATE_OPEN_PGP_KEY_PAIR.SUCCESS,
         transactionsTypes.MOVE_TRANSACTION.SUCCESS,
         synchronizationsTypes.MOVE_SYNCHRONIZATION.SUCCESS,

         partnersTypes.MOVE_PARTNER.SUCCESS,
         partnersTypes.CREATE_PARTNER.SUCCESS,
         sftpUsersTypes.MOVE_SFTP_GROUP.SUCCESS,
         sftpUsersTypes.MOVE_SFTP_USER.SUCCESS,
      ],
      loadTreeNavSaga
   );
}
